/*
 This file is part of GNU Taler
 (C) 2022-2024 Taler Systems S.A.

 GNU Taler is free software; you can redistribute it and/or modify it under the
 terms of the GNU General Public License as published by the Free Software
 Foundation; either version 3, or (at your option) any later version.

 GNU Taler is distributed in the hope that it will be useful, but WITHOUT ANY
 WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR
 A PARTICULAR PURPOSE.  See the GNU General Public License for more details.

 You should have received a copy of the GNU General Public License along with
 GNU Taler; see the file COPYING.  If not, see <http://www.gnu.org/licenses/>
 */

import { TalerProtocolDuration } from "@gnu-taler/taler-util";
import type {
  AcceptTosFormDesign,
  InternationalizationAPI,
} from "@gnu-taler/web-util/browser";

export type AcceptTermOfServiceContext = {
  tos_url: string;
  provider_name?: string;
  expiration_time?: TalerProtocolDuration;
  successor_measure?: string;
  tos_version: string;

  /**
   * Only open the attached link, do not offer both "view in browser"
   * and "download PDF" options.
   */
  link_only?: boolean;

  /**
   * @deprecated deprecated alias of tos_version.
   */
  tosVersion?: string;
};

/**
 *
 * @param i18n
 * @param context
 * @returns
 */
export function acceptTos(
  _i18n: InternationalizationAPI,
  context: AcceptTermOfServiceContext,
): AcceptTosFormDesign {
  return {
    type: "accept-tos",
    tosUrl: context.tos_url,
    tosVersion: context.tos_version ?? context.tosVersion ?? "",
    providerName: context.provider_name,
    linkOnly: context.link_only,
  };
}
